import { createApiModule } from './base';
import api from '../lib/axios';

// Métodos customizados específicos para Auth
const authCustomMethods = {
  // Login
  login: (email, password) => api.post('/auth/login', { email, password }),

  // Logout
  logout: () => api.post('/auth/logout'),

  // Obter dados do usuário logado
  me: () => api.get('/auth/user-profile'),

  // Refresh token
  refresh: () => api.post('/auth/refresh'),

  // Verificar email
  verifyEmail: token => api.post('/auth/verify-email', { token }),

  // Reenviar verificação de email
  resendVerification: () => api.post('/auth/resend-verification'),

  // Habilitar 2FA
  enableTwoFactor: () => api.post('/auth/2fa/enable'),

  // Confirmar 2FA
  confirmTwoFactor: code => api.post('/auth/2fa/confirm', { code }),

  // Desabilitar 2FA
  disableTwoFactor: code => api.post('/auth/2fa/disable', { code }),

  // Verificar código 2FA
  verifyTwoFactor: code => api.post('/auth/2fa/verify', { code }),

  // Obter status do 2FA
  getTwoFactorStatus: () => api.get('/auth/2fa/status'),

  // Esqueci minha senha (email + CPF)
  forgotPassword: (email, cpf) => api.post('/auth/password/forgot', { email, cpf }),

  // Validar token de reset
  validateResetToken: (email, token) =>
    api.get('/auth/password/validate', { params: { email, token } }),

  // Resetar senha
  resetPassword: (email, token, password, password_confirmation) =>
    api.post('/auth/password/reset', { email, token, password, password_confirmation }),

  // Atualizar perfil do usuário autenticado
  updateProfile: data => api.put('/auth/profile', data),
};

// Criar módulo de API padronizado para Auth
export const authApi = createApiModule('auth', authCustomMethods);
